<script>
import { BaseService } from '@/services/base.service';
import BaseSelectFilter from '@/modules/_global/_components/filters/BaseSelectFilter.vue';

export default {
  name: 'StatusFilter',

  extends: BaseSelectFilter,

  props: {
    multiple: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    getData() {
      return BaseService.getStatuses()
        .then(({ data }) => {
          return data.data;
        })
        .catch(console.error);
    }
  }
};
</script>
